import type { Schedule } from "~/core";

export const isSchedule = (item: unknown): item is Schedule => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "schedule"
  );
};
